var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-c1599d27-1195-411a-a392-aba5fff398d5",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-6cab6e27-a4fb-48a6-ae38-82a4682566df {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-6cab6e27-a4fb-48a6-ae38-82a4682566df",
    d: "M22.59,22.18l-2.81-2.81c.68-.96,1.08-2.12,1.08-3.38,0-3.24-2.63-5.87-5.87-5.87s-5.87,2.63-5.87,5.87,2.63,5.87,5.87,5.87c1.26,0,2.42-.4,3.38-1.08l2.81,2.81c.2.2.45.29.71.29s.51-.1.71-.29c.39-.39.39-1.02,0-1.41ZM11.11,15.99c0-2.14,1.74-3.87,3.87-3.87s3.87,1.74,3.87,3.87-1.74,3.87-3.87,3.87-3.87-1.74-3.87-3.87Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.a318eed7dd7c1708e0efbfb7458eb251.svg";
export { ForwardRef as ReactComponent };